export const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL || 'https://nwl42k6a0tg.execute-api.ap-south-1.amazonaws.com/qa/graphql';
// export const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL || 'http://localhost:7000/graphql';
